export default __webpack_public_path__ + "quick-actions-mcp-servers.f86c9b91.svg";